// import logo from './logo.svg';
import './App.css';
import { 
  // BrowserRouter as Router,
   Routes ,Route, HashRouter } from 'react-router-dom';

// Assuming you have components for Login and Dashboard
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Supplier_Dashboard from './pages/supplier-dashboard';
import ActivityDashboard from './pages/activity-dashboard';
import ProductTable from './pages/product-details';
import Scan from './pages/scan';
import ExporScnned from './pages/export';
import OrdersStockPrint from './pages/orders-stock-print';

function App() {
  // Simulate authentication status. You can replace this with your actual authentication logic.


  return (
    <HashRouter>
    {/* <Layout> */}
      <Routes>
        <Route exact path="/" element={<Login/>}/>
        <Route exact path="/login" element={<Login/>}/>
        <Route exact path="/dashboard" element={<Dashboard/>}/>
        <Route exact path="/supplier-dashboard" element={<Supplier_Dashboard/>}/>
        <Route exact path="/danielli-dashboard" element={<ActivityDashboard/>}/>
        <Route exact path="/store/:id/:clientName" element={<ProductTable/>}/>
        {/* <Route exact path="/orders-stock" element={<ProductTable ordersStockMode />}/> */}
        <Route exact path="/orders-stock-print" element={<OrdersStockPrint/>}/>
        <Route exact path="/scan/:id" element={<Scan/>}/>
        <Route exact path="/export-scan" element={<ExporScnned/>}/>
        {/* <Route path="*" element={<NotFound/>}/> */}
      </Routes>
    {/* </Layout> */}
  </HashRouter>
  );
}

export default App;
